import React, { useEffect, useState } from 'react';
import Button from 'components/atoms/Button';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import checkMail from '../../../assets/svg/checkMail.svg';
import arrowLeft from '../../../assets/svg/larrow-left-long.svg';
import Alert from 'components/atoms/Alert';
import PageTitle from 'components/atoms/PageTitle';
import { BASE_URL, postRequest } from 'services/http';

const CheckMail = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const recoveryMail = state?.recoveryEmail;

  useEffect(() => {
    if (!recoveryMail) {
      navigate('/auth/forgot_password');
    }
  }, [recoveryMail, navigate]);

  const forgotPassword = async (email: string) => {
    setLoading(true);
    try {
      const res = await postRequest(
        `${BASE_URL}auth/password`,
        { headers: { 'Content-Type': 'application/json' } },
        { email }
      );

      const alertType = res?.data.responseCode === '00' ? 'success' : 'error';
      Alert(alertType, res?.data.message);
    } catch (error) {
      Alert('error', 'An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <img src={checkMail} alt="Check Mail" className="w-[40px] h-[40px] mb-3" />
      <PageTitle
        pageTitle="Check your mail"
        pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
        subTitle={
          <p className="font-normal text-[16px] leading-7 text-Black2 flex-wrap">
            We have sent an OTP to{' '}
            <span className="text-DarkBg3 font-normal">{recoveryMail}</span>
          </p>
        }
      />
      <span>
        <Button
          btnType="button"
          btnText="Continue to Create New Password"
          btnStyle="bg-black text-sm text-white px-6 py-3 mt-12 w-full"
          onClick={() =>
            navigate('/auth/create_new_password', {
              state: { recoveryEmail: recoveryMail },
            })
          }
          disabled={loading}
        />
      </span>
      <button
        className="flex justify-start mt-3 text-black text-sm leading-7"
        onClick={() => forgotPassword(recoveryMail)}
        disabled={loading}
      >
        Didn’t get the mail?{' '}
        <span className="text-PrimaryActive ml-1 hover:underline hover:transition-all cursor-pointer">
          Resend Link
        </span>
      </button>
      <Link
        to="/auth/login"
        className="flex justify-start items-center gap-3 mt-1 font-semibold text-black text-sm leading-7 cursor-pointer hover:underline hover:transition-all"
      >
        <img src={arrowLeft} alt="Back to Login" className="w-4 h-4" />
        Back to Login
      </Link>
    </form>
  );
};

export default CheckMail;